import { OnboardingTemplatesTableFields } from './enums'

export const onboardingTemplateTableHeaderTitles: Record<OnboardingTemplatesTableFields, string> = {
  [OnboardingTemplatesTableFields.id]: 'Template ID',
  [OnboardingTemplatesTableFields.name]: 'Name',
  [OnboardingTemplatesTableFields.stepCount]: 'Steps',
  [OnboardingTemplatesTableFields.steps]: 'What it collects',
  // The actions column is buttons only; a header would just add noise.
  [OnboardingTemplatesTableFields.actions]: '',
}

// A per-customer list of a handful of rows, so this stops at 100 — same reasoning as markets.
export const onboardingTemplatePageSizeOptions = [25, 50, 100]

export const ONBOARDING_TEMPLATES_GRID_COLUMNS_STORAGE_KEY = 'admin.onboardingTemplates.gridColumns'

// Step chips shown inline before collapsing the remainder into "+N".
export const MAX_VISIBLE_STEP_CHIPS = 3
